export default __webpack_public_path__ + "static/media/imagemCP.a409f708.jpg";